import React, { useContext } from 'react'
import { PIMCORE_URL, ENDPOINTS } from '../../constants'
import Button from 'react-bootstrap/Button'
import AppContext from '../context/app'

export default function RemoveFromCart({ children, className, style, product, el }) {
    const { cartId, loadingCart, setLoadingCart, setCart, setShowCart } = useContext(AppContext)

    async function handleOnClick() {
        const property = process.env.GATSBY_ENVIRONMENT_PRODUCTION === 'true' ?
            'pimcoreProductionId' :
            'pimcoreStagingId'
        
        const id = product[property]
        if(!id) return

        if (el) el.current.classList.add('text-decoration-line-through')

        const options = {
            method: 'post',
            body: JSON.stringify({
                id,
                session_cart_id: cartId,
            })
        }

        try{
            setLoadingCart(true)
            const r = await fetch(`${PIMCORE_URL}${ENDPOINTS.REMOVE_FROM_CART}`, options)
            const { success, data } = await r.json()
            
            if (success){
                setCart(data)                
            }

            // Close cart if it was the only product in the cart
            if(!data) {
                setShowCart(false)
            }
        } catch(e){
            if (el) el.current.classList.remove('text-decoration-line-through')
            
            console.log(`Error removing ${product.product_name} to cart`)
            console.error(e)
        } finally {
            setLoadingCart(false)
        }
    }

    return (
        <Button
            variant=''
            disabled={loadingCart}
            onClick={handleOnClick}
            className={className}
            style={style}
        >
            {children}
        </Button>
    )
}
